/** A pinned version's notes. They are coach-authored text, so they render as
 * plain text only: line breaks are kept, nothing becomes markdown or a link.
 * A version without notes renders nothing. */
export function ResourceNotes({ notes, className = '' }: { notes: string; className?: string }) {
  if (!notes) return null;
  return <p data-testid="pinned-resource-notes" className={`whitespace-pre-wrap break-words text-sm text-ink ${className}`}>{notes}</p>;
}
